import { createAsyncThunk } from '@reduxjs/toolkit';

import { mediaService } from '@/services';
import { handleThunkApiError } from '@/utils';

export const createMedia = createAsyncThunk(
  'media/create-media',
  handleThunkApiError(mediaService.createMedia),
);
